import { SAUTableModule } from '@some-angular-utils/table';

/**
 * Global patch for every `<sau-table>`: if a fetch comes back with no rows while on a page
 * other than the first (typically after deleting the last row of the last page), step back
 * to the previous page and refetch, instead of leaving the user on an empty "No hay
 * elementos" page with no paginator to get out of it.
 *
 * The current page lives only in the component instance (in memory) - it is deliberately
 * never persisted (no localStorage/sessionStorage/URL), so a browser reload always starts
 * back on page 1.
 *
 * Patched on the prototype (imported once from main.ts) rather than per page, since every
 * list page uses `<sau-table>` directly. Tables without `url` (nested `[items]` tables) are
 * left alone.
 */
const originalAfterViewInit = SAUTableModule.prototype.ngAfterViewInit;

SAUTableModule.prototype.ngAfterViewInit = function (this: SAUTableModule) {
  this.itemsLoadedEvent.subscribe((items: any[]) => {
    if (!this.url || items.length > 0 || this.page <= 1) return;

    // `total` is the page count (0 when the table has no `contentTotal`)
    this.page = this.total > 0 ? Math.min(this.page - 1, this.total) : this.page - 1;
    this.getItems();
  });

  originalAfterViewInit.call(this);
};
